import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import VideoItem from '../components/video/VideoItem';
import {showVideoFlag, setVideoSoundItem, createVideo} from '../actions';


class VideoContainer extends Component {

  constructor(props){
    super(props);
    this.state={};
    this.handleMute = this.handleMute.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillReceiveProps(nextProps){
    const {videoItem} = this.props;
    if(videoItem !== nextProps.videoItem){
      if(videoItem.video1 !== nextProps.videoItem.video1) this.handleMute('video1');
      if(videoItem.video2 !== nextProps.videoItem.video2) this.handleMute('video2');
      if(videoItem.video3 !== nextProps.videoItem.video3) this.handleMute('video3');
      if(videoItem.video4 !== nextProps.videoItem.video4) this.handleMute('video4');
      this.props.showVideoFlag(true);
    }
  }


  
  handleMute(id, volume){
   if(volume === undefined) {
      this.props.setVideoSoundItem(id);
    } else {
      if(volume > 0) this.props.setVideoSoundItem(id);
    }
  }

  handleClose(id){
    const {videoItem} = this.props;
    videoItem[id] = {};
    this.props.createVideo(videoItem);
  }

  render() {
    const {showVideo, videoItem, selectedMenu} = this.props;
    const {
      video1, video2, video3, video4
    } = videoItem;
    const toggle = {
      top: '-240px',
      position: 'absolute'
    };
    return (
      <div className='mxvl video-container' style={selectedMenu === 'DIVISION' ? toggle : showVideo ? null : toggle}>
        <VideoItem id='video1' videoItem={video1} handleMute={this.handleMute} handleClose={this.handleClose}/>
        <VideoItem id='video2' videoItem={video2} handleMute={this.handleMute} handleClose={this.handleClose}/>
        <VideoItem id='video3' videoItem={video3} handleMute={this.handleMute} handleClose={this.handleClose}/>
        <VideoItem id='video4' videoItem={video4} handleMute={this.handleMute} handleClose={this.handleClose}/>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    selectedMenu: state.selectedMenu,
    videoItem: state.videoItem,
    activeVideo: state.activeVideo
  }
};
const mapDispatcherToProps = dispatch => {
  return {
    createVideo: (videoItem) => dispatch(createVideo(videoItem)),
    showVideoFlag: (videoFlag) => dispatch(showVideoFlag(videoFlag)),
    setVideoSoundItem: (activeVideo) => dispatch(setVideoSoundItem(activeVideo))
  }
};

VideoContainer = connect(mapStateToProps,mapDispatcherToProps)(VideoContainer);

export default VideoContainer;


// WEBPACK FOOTER //
// ./src/containers/VideoContainer.js